import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SpotDetailsModalPageRoutingModule } from './spot-details-modal-routing.module';

import { SpotDetailsModalPage } from './spot-details-modal.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SpotDetailsModalPageRoutingModule
  ],
  declarations: [SpotDetailsModalPage]
})
export class SpotDetailsModalPageModule {}
